import { useState } from "react";
import { Helmet } from "react-helmet";
import { ADDRESS, EMAIL, PHONE_DISPLAY, PHONE_TEL, SITE_URL, WHATSAPP_URL } from "./App";

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);

  return (
    <>
      <Helmet>
        <title>Contact Tax Consultant in Lahore | Axis Compliance Solutions</title>
        <meta
          name="description"
          content="Contact Axis Compliance Solutions for international bookkeeping, bank reconciliation, tax filing, SECP company registration, FBR compliance, sales tax, NTN, STRN and audit support."
        />
        <link rel="canonical" href={`${SITE_URL}/contact`} />
        <meta property="og:title" content="Contact Tax Consultant in Lahore | Axis Compliance Solutions" />
        <meta
          property="og:description"
          content="Contact Axis Compliance Solutions for bookkeeping, bank reconciliation, tax filing, SECP registration and FBR compliance."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${SITE_URL}/contact`} />
        <meta property="og:image" content={`${SITE_URL}/axis-logo.png`} />
        <meta property="og:image:alt" content="Axis Compliance Solutions contact details" />
        <meta name="twitter:title" content="Contact Tax Consultant in Lahore | Axis Compliance Solutions" />
        <meta
          name="twitter:description"
          content="Book a consultation for bookkeeping, tax filing, company registration and compliance support."
        />
        <meta name="twitter:image" content={`${SITE_URL}/axis-logo.png`} />
        <meta name="twitter:image:alt" content="Axis Compliance Solutions contact details" />
      </Helmet>

      <section className="page-hero">
        <div className="mx-auto max-w-7xl px-4 lg:px-8">
          <p className="eyebrow text-cyan-200">Contact</p>
          <h1>Book a consultation with a tax and compliance advisor.</h1>
          <p>
            Send your question, deadline or registration requirement. The team will guide you on
            the next step for filing, registration, international bookkeeping, bank
            reconciliation or compliance support.
          </p>
        </div>
      </section>

      <section className="section bg-white">
        <div className="mx-auto grid max-w-7xl gap-10 px-4 lg:grid-cols-[1fr_0.9fr] lg:px-8">
          <div className="rounded-md border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
            <p className="eyebrow">Send a message</p>
            <h2 className="mt-2 text-3xl font-semibold text-slate-950">Tell us how we can help.</h2>
            <form action="https://formsubmit.co/sbaig1749@gmail.com" method="POST" className="mt-8 grid gap-4">
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_template" value="table" />
              <input type="hidden" name="_subject" value="New Contact Submission" />
              <div className="grid gap-4 sm:grid-cols-2">
                <input className="field" type="text" name="name" placeholder="Full name" required />
                <input className="field" type="tel" name="phone" placeholder="Mobile number" required />
              </div>
              <input className="field" type="email" name="email" placeholder="Email address" required />
              <select className="field" name="service" defaultValue="Tax consultation">
                <option>Tax consultation</option>
                <option>Income tax filing</option>
                <option>SECP company registration</option>
                <option>FBR, SRB, PRA or BRA compliance</option>
                <option>Bookkeeping, bank reconciliation or audit support</option>
                <option>PSEB registration</option>
              </select>
              <textarea className="field min-h-36" name="message" placeholder="Share your question, deadline or current issue" required />
              <button className="btn-primary" type="submit" onClick={() => setSubmitted(true)}>
                Send Message
              </button>
            </form>
            {submitted && (
              <p className="mt-4 rounded-md bg-emerald-50 p-3 text-center text-sm font-medium text-emerald-800">
                Thank you. Your message has been prepared for submission.
              </p>
            )}
          </div>

          <div className="space-y-6">
            <div className="rounded-md bg-slate-950 p-6 text-white sm:p-8">
              <p className="eyebrow text-cyan-200">Office details</p>
              <div className="mt-6 space-y-5 text-slate-200">
                <div>
                  <h3 className="font-semibold text-white">Address</h3>
                  <p className="mt-1">{ADDRESS}</p>
                </div>
                <div>
                  <h3 className="font-semibold text-white">Phone</h3>
                  <a className="mt-1 inline-block hover:text-cyan-200" href={`tel:${PHONE_TEL}`}>{PHONE_DISPLAY}</a>
                </div>
                <div>
                  <h3 className="font-semibold text-white">Email</h3>
                  <a className="mt-1 inline-block hover:text-cyan-200" href={`mailto:${EMAIL}`}>{EMAIL}</a>
                </div>
                <div>
                  <h3 className="font-semibold text-white">Office Hours</h3>
                  <p className="mt-1">Monday to Saturday, 10:00 AM to 6:00 PM</p>
                </div>
              </div>
              <a className="btn-light mt-7 w-full text-center" href={WHATSAPP_URL} target="_blank" rel="noreferrer">
                Start WhatsApp Chat
              </a>
            </div>

            <div className="overflow-hidden rounded-md border border-slate-200 bg-slate-100 shadow-sm">
              <iframe
                title="Axis Compliance Solutions office map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13610.784457636957!2d74.32937620000001!3d31.5203694!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391904eebdb9e789%3A0x1d8f2b58e8e8f4b6!2sLahore%2C%20Pakistan!5e0!3m2!1sen!2s!4v1687200595555"
                width="100%"
                height="320"
                loading="lazy"
                allowFullScreen=""
                referrerPolicy="no-referrer-when-downgrade"
                className="block"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
